export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6391.43908280.jpg";